import React, { useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Center from '@components/common/alignment/Center';
import LargeBlueButton from '@components/common/button/LargeBlueButton';
import ContentBox from '@components/common/ContentBox';
import AuthFormField from '@components/common/form/AuthFormField';
import { useHistory } from 'react-router-dom';
import { mapAuthError } from '@util/mapFirebaseError';

const ForgotPassword: React.FC = () => {
  const [error, setError] = useState('');
  const history = useHistory();

  const sendResetEmail = ({ email }: { email: string }) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        history.push('/resetsent');
      })
      .catch((err: firebase.auth.AuthError) => {
        setError(mapAuthError(err));
      });
  };

  const validationScheme = Yup.object().shape({
    email: Yup.string().required('Email is required.').email('Invalid email.'),
  });

  return (
    <Center>
      <p className='text-coffee text-5xl font-raleway font-bold my-4'>RESET PASSWORD</p>
      <ContentBox>
        <Formik
          initialValues={{ email: '' }}
          onSubmit={sendResetEmail}
          validationSchema={validationScheme}
        >
          <Form
            className='w-full h-full flex flex-col font-raleway'
            onChange={() => {
              if (error !== '') {
                setError('');
              }
            }}
          >
            <AuthFormField name='email'></AuthFormField>
            <text className='text-red-600 text-center whitespace-pre-line'>{error}</text>
            <div className='text-center mt-8'>
              <LargeBlueButton text='SEND EMAIL' type='submit'></LargeBlueButton>
            </div>
          </Form>
        </Formik>
      </ContentBox>
    </Center>
  );
};

export default ForgotPassword;
